import { ModelJson, PageModelState } from './types';
import { networkInitialState } from '../network';

export const PageModelInitialState: PageModelState = {
	data: {} as ModelJson,
	network: networkInitialState,
};
